<script setup>
import AgentsMain from '@/components/agents/AgentsMain.vue'
</script>

<template>
  <agents-main />
</template>
